// headlight-report-project-assignment — shared pict-view that assigns report/form definitions
// (ReportNamedInstance) to projects via ReportNamedInstanceProjectJoin, with a searchable project list,
// linked-forms management (add / pull-in-defaults / drag-reorder / remove), My Daily designation and
// repair, an L5-only bulk-add modal, and a project-level LIMS-concierge gate.
//
// My Daily: ReportNamedInstancesByProject issues no ORDER BY and its handler pins element [0] before
// alphabetizing the rest, so the project's daily report is whichever join the IDProject index yields
// first — in practice the lowest IDReportNamedInstanceProjectJoin. The joins table badges that row and
// offers "Make My Daily" on the others, which swaps the two rows' IDReportNamedInstance values through
// a -1 parking write (AK_ReportNamedInstanceProjectJoin is UNIQUE on (IDReportNamedInstance, IDProject)
// with no soft delete). The table's own order is Ordinal, which no server code reads today.
//
// Host couplings are injected via the view's options:
//   - DefaultDestinationAddress : the container selector to render into (per host)
//   - FormGroups                : materials-form-manager FORM_GROUPS (enables the bulk-add modal; omit/null to hide it)
//   - IsLIMSForm                : materials-form-manager isLIMSForm(hashOrName) predicate (defaults to a no-op)
// Re-exports the view class and its default_configuration so a host can `addView` it directly.

const libReportNamedInstanceProjectAssignment = require('./ReportNamedInstance-ProjectAssignment.js');

module.exports = libReportNamedInstanceProjectAssignment;
module.exports.default_configuration = libReportNamedInstanceProjectAssignment.default_configuration;
